(function ($) {
  function getCsrfToken() {
    var token = $('meta[name="csrf-token"]').attr('content');

    if (!token) {
      return '';
    }

    return token;
  }

  function ensureCsrfInput(form) {
    var $form = $(form);
    var method = $form.attr('method');
    var token = getCsrfToken();

    if (!method) {
      return;
    }

    if (method.toUpperCase() !== 'POST') {
      return;
    }

    if (!token) {
      return;
    }

    var $input = $form.find('input[name="csrf_token"]');
    if ($input.length > 0) {
      $input.val(token);
      return;
    }

    $('<input>', {
      type: 'hidden',
      name: 'csrf_token',
      value: token
    }).appendTo($form);
  }

  function initializeCsrfForms() {
    $('form').each(function () {
      ensureCsrfInput(this);
    });

    $(document).on('submit', 'form', function () {
      ensureCsrfInput(this);
    });
  }

  // A barra de acao em lote so aparece quando existe linha marcada, e
  // fica logo acima da tabela para o usuario nao precisar procurar.
  function refreshBulkBar() {
    var $barra = $('[data-bulk-bar]');

    if (!$barra.length) {
      return;
    }

    var $marcados = $('input[name="ids[]"]:checked');
    var $selecionarTodos = $('[data-bulk-select-all]');
    var total = $('input[name="ids[]"]').length;

    // Conta uma vez e reaproveita: o mesmo numero vai no rotulo das
    // tres opcoes e depois na mensagem de confirmacao.
    var quantidade = $marcados.length;

    $barra.find('option[data-bulk-label]').each(function () {
      var $opcao = $(this);
      $opcao.text($opcao.attr('data-bulk-label') + ' (' + quantidade + ')');
    });

    if (quantidade === 0) {
      $barra.attr('hidden', 'hidden');
    } else {
      $barra.removeAttr('hidden');
    }

    // Guarda o numero na propria barra para o modal reaproveitar em vez
    // de contar os checkboxes de novo.
    $barra.attr('data-bulk-selected', quantidade);

    // Estado intermediario quando so parte das linhas esta marcada.
    if ($selecionarTodos.length) {
      $selecionarTodos.prop('indeterminate', quantidade > 0 && quantidade < total);
      $selecionarTodos.prop('checked', total > 0 && quantidade === total);
    }
  }

  function initializeBulkSelection() {
    $(document).on('change', '[data-bulk-select-all]', function () {
      var checked = $(this).is(':checked');
      $(this).closest('table').find('input[name="ids[]"]').prop('checked', checked);
      refreshBulkBar();
    });

    $(document).on('change', 'input[name="ids[]"]', function () {
      refreshBulkBar();
    });

    // Escolher a acao ja pede confirmacao, dizendo quantos registros
    // vao ser alterados. Nao existe botao "aplicar".
    $(document).on('change', '[data-bulk-operation-select]', function () {
      var $select = $(this);
      var operacao = $select.val();

      if (!operacao) {
        return;
      }

      var $form = $select.closest('form');
      var rotulo = $select.find('option:selected').attr('data-bulk-label');
      var quantidade = parseInt($form.attr('data-bulk-selected'), 10) || 0;
      var mensagem = readAttribute($form, 'data-confirm-message', '{count} / {action}');

      mensagem = mensagem.replace('{count}', quantidade).replace('{action}', rotulo);

      openConfirmDialog({
        title: readAttribute($form, 'data-confirm-title', 'Confirmar'),
        message: mensagem,
        button: readAttribute($form, 'data-confirm-button', 'Confirmar'),
        icon: bulkOperationIcon(operacao)
      }, function () {
        // submit() foi sobrescrito acima e ja injeta o token CSRF.
        $form.find('[data-bulk-operation-value]').val(operacao);
        $form[0].submit();
      });
    });

    // Cancelou: volta o select para o estado neutro.
    $(document).on('hidden.bs.modal', '#confirmActionModal', function () {
      $('[data-bulk-operation-select]').val('');
    });

    refreshBulkBar();
  }

  function bulkOperationIcon(operacao) {
    if (operacao === 'activate') {
      return 'bi-check-circle';
    }

    if (operacao === 'deactivate') {
      return 'bi-pause-circle';
    }

    return 'bi-archive';
  }

  function protectDirectFormSubmit() {
    var nativeSubmit = HTMLFormElement.prototype.submit;

    HTMLFormElement.prototype.submit = function () {
      ensureCsrfInput(this);
      nativeSubmit.call(this);
    };
  }

  function initializeDropdowns() {
    if (typeof bootstrap === 'undefined') {
      return;
    }

    $('[data-bs-toggle="dropdown"]').each(function () {
      new bootstrap.Dropdown(this, { popperConfig: { strategy: 'fixed' } });
    });
  }

  function readAttribute($element, attribute, fallback) {
    var value = $element.attr(attribute);

    if (!value) {
      return fallback;
    }

    return value;
  }

  function openConfirmDialog(options, onConfirm) {
    var $modal = $('#confirmActionModal');

    if ($modal.length === 0) {
      return;
    }

    if (typeof bootstrap === 'undefined') {
      return;
    }

    var title = options.title || 'Confirmar ação';
    var message = options.message || 'Essa ação não pode ser desfeita.';
    var button = options.button || 'Confirmar';
    var icon = options.icon || 'bi-trash';

    $('#confirmActionTitle').text(title);
    $('#confirmActionMessage').text(message);
    $('#confirmActionSubmit span').text(button);
    $('#confirmActionSubmit i').attr('class', 'bi ' + icon);

    $('#confirmActionSubmit')
      .off('click.rankupConfirm')
      .on('click.rankupConfirm', function () {
        var modal = bootstrap.Modal.getOrCreateInstance($modal[0]);
        modal.hide();
        onConfirm();
      });

    $modal
      .off('hidden.bs.modal.rankupConfirm')
      .on('hidden.bs.modal.rankupConfirm', function () {
        $('#confirmActionSubmit').off('click.rankupConfirm');
      });

    bootstrap.Modal.getOrCreateInstance($modal[0]).show();
  }

  function initializeConfirmForms() {
    $(document).on('submit', 'form[data-confirm-modal="1"]', function (event) {
      var form = this;
      var $form = $(form);

      event.preventDefault();

      openConfirmDialog({
        title: readAttribute($form, 'data-confirm-title', 'Confirmar ação'),
        message: readAttribute($form, 'data-confirm-message', 'Essa ação não pode ser desfeita.'),
        button: readAttribute($form, 'data-confirm-button', 'Confirmar'),
        icon: readAttribute($form, 'data-confirm-icon', 'bi-trash')
      }, function () {
        ensureCsrfInput(form);
        form.submit();
      });
    });
  }

  function getCurrencySymbol(currencyCode) {
    var code = '';
    if (currencyCode) {
      code = String(currencyCode).toUpperCase();
    }

    if (code === 'BRL') {
      return 'R$';
    }

    if (code === 'EUR') {
      return '€';
    }

    return '$';
  }

  function initializeFilterCards() {
    $(document).on('click', '.filter-hd', function () {
      $(this).closest('.filter-card').toggleClass('open');
    });
  }

  function initializeSidebar() {
    var $app     = $('#appRoot');
    var $sidebar = $('#mainSidebar');
    var $overlay = $('#sidebarOverlay');
    var $toggleBtn  = $('#sidebarToggle');
    var $toggleIcon = $('#sidebarToggleIcon');
    var $hamburger  = $('#hamburgerBtn');
    var storageKey = 'rkSidebarCollapsed';
    var legacyKey = 'sidebarCollapsed';

    if (!$app.length) {
      return;
    }

    var stored = localStorage.getItem(storageKey);

    if (stored === null && localStorage.getItem(legacyKey) !== null) {
      stored = localStorage.getItem(legacyKey);
      localStorage.setItem(storageKey, stored);
      localStorage.removeItem(legacyKey);
    }

    if (stored === '1') {
      $app.addClass('collapsed');
      $toggleIcon.removeClass('bi-chevron-left').addClass('bi-chevron-right');
      $toggleBtn.attr('title', 'Expandir');
    }

    $toggleBtn.on('click', function () {
      $app.toggleClass('collapsed');
      var c = $app.hasClass('collapsed');
      localStorage.setItem(storageKey, c ? '1' : '0');
      $toggleIcon.toggleClass('bi-chevron-left', !c).toggleClass('bi-chevron-right', c);
      $toggleBtn.attr('title', c ? 'Expandir' : 'Recolher');
    });

    $hamburger.on('click', function () {
      $sidebar.addClass('mobile-open');
      $overlay.addClass('open');
    });

    $overlay.on('click', function () {
      $sidebar.removeClass('mobile-open');
      $overlay.removeClass('open');
    });
  }

  function initializeCurrencyPrefixes() {
    $(document).on('change', '[data-currency-prefix-target]', function () {
      var selector = $(this).attr('data-currency-prefix-target');

      if (!selector) {
        return;
      }

      $(selector).text(getCurrencySymbol($(this).val()));
    });
  }

  function updateFilePicker(input) {
    var $input = $(input);
    var $picker = $input.closest('.file-picker');
    var $name = $picker.find('[data-file-picker-name]');
    var label = 'Nenhum arquivo selecionado';

    if ($input[0].files && $input[0].files.length > 0) {
      label = $input[0].files[0].name;
    }

    $name.text(label);
  }

  function initializeFilePickers() {
    $('.file-picker-input').each(function () {
      updateFilePicker(this);
    });

    $(document).on('change', '.file-picker-input', function () {
      updateFilePicker(this);
    });
  }

  function copyTextToClipboard(text, button) {
    if (!text) {
      return;
    }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      $(button).attr('title', 'Copiado');
      return;
    }

    var $temporary = $('<textarea>');
    $temporary.val(text);
    $temporary.attr('readonly', 'readonly');
    $temporary.css({
      position: 'fixed',
      top: '-9999px'
    });
    $('body').append($temporary);
    $temporary[0].select();
    document.execCommand('copy');
    $temporary.remove();
    $(button).attr('title', 'Copiado');
  }

  function initializeCopyButtons() {
    $(document).on('click', '[data-copy-text]', function () {
      copyTextToClipboard($(this).attr('data-copy-text'), this);
    });
  }

  function initializeErrorPage() {
    var $botao = $('#errorGoBack');

    if (!$botao.length) {
      return;
    }

    if (!document.referrer) {
      $botao.hide();
      return;
    }

    $botao.on('click', function () {
      window.history.back();
    });
  }

  function initializeOnboardingCard() {
    var $card = $('.onboarding-card');

    if (!$card.length) {
      return;
    }

    var chave = 'rkOnboardingDismissed_' + $card.attr('data-onboarding-company');

    if (localStorage.getItem(chave) === '1') {
      $card.hide();
      return;
    }

    $card.on('click', '.onboarding-dismiss', function () {
      localStorage.setItem(chave, '1');
      $card.slideUp(150);
    });
  }

  function updateBillingPeriod($selector, intervalo) {
    if (intervalo !== 'monthly' && intervalo !== 'annual') {
      return;
    }

    $selector.attr('data-selected-interval', intervalo);

    $selector.find('[data-billing-interval]').each(function () {
      var $opcao = $(this);
      var selecionada = $opcao.attr('data-billing-interval') === intervalo;

      $opcao.toggleClass('active', selecionada);
      $opcao.attr('aria-pressed', 'false');
      if (selecionada) {
        $opcao.attr('aria-pressed', 'true');
      }
    });

    $('[data-billing-plan-card]').each(function () {
      var $cartao = $(this);
      var planoAtual = $cartao.attr('data-current-plan') === '1';
      var intervaloAtual = $cartao.attr('data-current-interval');
      var assinaturaAtual = planoAtual && intervaloAtual === intervalo;

      $cartao.find('[data-billing-plan-price]').text($cartao.attr('data-price-' + intervalo));
      $cartao.find('[data-billing-plan-kicker]').text($cartao.attr('data-kicker-' + intervalo));
      $cartao.find('[data-billing-plan-period]').text($cartao.attr('data-period-' + intervalo));
      $cartao.find('[data-billing-price-support]').text($cartao.attr('data-support-' + intervalo));
      $cartao.find('[data-billing-per-seller]').text($cartao.attr('data-seller-' + intervalo));
      $cartao.find('[data-billing-interval-input]').val(intervalo);
      $cartao.find('[data-billing-annual-badge]').prop('hidden', intervalo !== 'annual');
      $cartao.find('[data-billing-current-badge]').prop('hidden', !assinaturaAtual);
      $cartao.find('[data-billing-subscribe-action]').prop('hidden', assinaturaAtual);
      $cartao.find('[data-billing-current-action]').prop('hidden', !assinaturaAtual);
      $cartao.toggleClass('current', assinaturaAtual);
    });
  }

  function initializeBillingPeriods() {
    var $selector = $('[data-billing-period-selector]');

    if ($selector.length === 0) {
      return;
    }

    $selector.on('click', '[data-billing-interval]', function () {
      updateBillingPeriod($selector, $(this).attr('data-billing-interval'));
    });

    updateBillingPeriod($selector, $selector.attr('data-selected-interval'));
  }

  function updateCompanyCnpjField(select) {
    var $select = $(select);
    var $form = $select.closest('form');
    var $field = $form.find('[data-company-cnpj-field]');
    var $input = $field.find('[data-company-cnpj]');

    if ($field.length === 0) {
      return;
    }

    if ($select.val() === 'BRA') {
      $field.prop('hidden', false);
      $input.prop('required', true);
      return;
    }

    $field.prop('hidden', true);
    $input.prop('required', false);
    $input.val('');
  }

  function initializeCompanyIdentityFields() {
    $('[data-company-country]').each(function () {
      updateCompanyCnpjField(this);
    });

    $(document).on('change', '[data-company-country]', function () {
      updateCompanyCnpjField(this);
    });

    $(document).on('input', '[data-company-cnpj]', function () {
      $(this).val($(this).val().toUpperCase());
    });
  }

  window.RankUpConfirm = {
    open: openConfirmDialog
  };

  $(function () {
    initializeCsrfForms();
    initializeBulkSelection();
    protectDirectFormSubmit();
    initializeDropdowns();
    initializeFilterCards();
    initializeConfirmForms();
    initializeCurrencyPrefixes();
    initializeFilePickers();
    initializeSidebar();
    initializeCopyButtons();
    initializeErrorPage();
    initializeOnboardingCard();
    initializeBillingPeriods();
    initializeCompanyIdentityFields();
  });
})(jQuery);
